module.exports = __webpack_public_path__ + "static/media/TWELVE.f9fae5f8.png";